module.exports = __webpack_public_path__ + "img/PriceQuotations_RejectedQuotesFormCustomer.e9df11a9.svg";